"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntentType = exports.inferIntentTypeFromClientSecret = void 0;
const inferIntentTypeFromClientSecret = (clientSecret) => {
    if (clientSecret) {
        if (clientSecret.startsWith('seti'))
            return IntentType.Setup;
        if (clientSecret.startsWith('pi'))
            return IntentType.Payment;
    }
    return IntentType.None;
};
exports.inferIntentTypeFromClientSecret = inferIntentTypeFromClientSecret;
var IntentType;
(function (IntentType) {
    // Immediate payments
    IntentType[IntentType["Payment"] = 0] = "Payment";
    // Setup/confirm cards for future payments
    IntentType[IntentType["Setup"] = 1] = "Setup";
    // No card details or not being saved
    IntentType[IntentType["None"] = 2] = "None";
})(IntentType = exports.IntentType || (exports.IntentType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvX3YyL3JlZ2lzdHJhdGlvbi9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFjTyxNQUFNLCtCQUErQixHQUFHLENBQzdDLFlBQWlDLEVBQ3JCLEVBQUU7SUFDZCxJQUFJLFlBQVksRUFBRTtRQUNoQixJQUFJLFlBQVksQ0FBQyxVQUFVLENBQUMsTUFBTSxDQUFDO1lBQUUsT0FBTyxVQUFVLENBQUMsS0FBSyxDQUFDO1FBQzdELElBQUksWUFBWSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUM7WUFBRSxPQUFPLFVBQVUsQ0FBQyxPQUFPLENBQUM7S0FDOUQ7SUFFRCxPQUFPLFVBQVUsQ0FBQyxJQUFJLENBQUM7QUFDekIsQ0FBQyxDQUFDO0FBVFcsUUFBQSwrQkFBK0IsbUNBUzFDO0FBRUYsSUFBWSxVQU9YO0FBUEQsV0FBWSxVQUFVO0lBQ3BCLHFCQUFxQjtJQUNyQixpREFBTyxDQUFBO0lBQ1AsMENBQTBDO0lBQzFDLDZDQUFLLENBQUE7SUFDTCxxQ0FBcUM7SUFDckMsMkNBQUksQ0FBQTtBQUNOLENBQUMsRUFQVyxVQUFVLEdBQVYsa0JBQVUsS0FBVixrQkFBVSxRQU9yQiJ9